module.exports = __webpack_public_path__ + "img/horizontal_7_7_pp3_3009.3131f67e.png";